const modal = $('#js-modal');
const img = $('#js-modalImg');

$('.js-popup').each(function(index) {
	$(this).click(function() {
		img.attr('src', $(this).attr('src'));
		modal.show();
	})
});

modal.click(function() {
	$(this).hide();
});
